/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  BusinessUnitDto,
  BusinessUnitOverviewDtoFilterSortSearchPagedRequestDto,
  BusinessUnitOverviewDtoPagedResponseDto,
  BusinessUnitTreeNodeExtendedDto,
  BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto,
  EntityNotFoundErrorDetailsErrorResponseModel,
  GetSpendingRequestDto,
  InvalidPropertyValueErrorDetailsErrorResponseModel,
  LinkBusinessUnitRequestDto,
  LookupItemDto,
  SpendingDto,
} from '../models/index';
import {
    BusinessUnitDtoFromJSON,
    BusinessUnitDtoToJSON,
    BusinessUnitOverviewDtoFilterSortSearchPagedRequestDtoFromJSON,
    BusinessUnitOverviewDtoFilterSortSearchPagedRequestDtoToJSON,
    BusinessUnitOverviewDtoPagedResponseDtoFromJSON,
    BusinessUnitOverviewDtoPagedResponseDtoToJSON,
    BusinessUnitTreeNodeExtendedDtoFromJSON,
    BusinessUnitTreeNodeExtendedDtoToJSON,
    BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoFromJSON,
    BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoToJSON,
    EntityNotFoundErrorDetailsErrorResponseModelFromJSON,
    EntityNotFoundErrorDetailsErrorResponseModelToJSON,
    GetSpendingRequestDtoFromJSON,
    GetSpendingRequestDtoToJSON,
    InvalidPropertyValueErrorDetailsErrorResponseModelFromJSON,
    InvalidPropertyValueErrorDetailsErrorResponseModelToJSON,
    LinkBusinessUnitRequestDtoFromJSON,
    LinkBusinessUnitRequestDtoToJSON,
    LookupItemDtoFromJSON,
    LookupItemDtoToJSON,
    SpendingDtoFromJSON,
    SpendingDtoToJSON,
} from '../models/index';

export interface BusinessUnitsGetBusinessUnitByIdGETRequest {
    id: string;
    includeChildren?: boolean;
}

export interface BusinessUnitsGetBusinessUnitsCategorySpendingPOSTRequest {
    getSpendingRequestDto?: GetSpendingRequestDto;
}

export interface BusinessUnitsGetBusinessUnitsCompanySpendingPOSTRequest {
    getSpendingRequestDto?: GetSpendingRequestDto;
}

export interface BusinessUnitsGetBusinessUnitsOverviewPOSTRequest {
    businessUnitOverviewDtoFilterSortSearchPagedRequestDto?: BusinessUnitOverviewDtoFilterSortSearchPagedRequestDto;
}

export interface BusinessUnitsGetBusinessUnitsTreeOverviewPOSTRequest {
    businessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto?: BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto;
}

export interface BusinessUnitsLinkBusinessnUnitsPOSTRequest {
    linkBusinessUnitRequestDto?: LinkBusinessUnitRequestDto;
}

/**
 * BusinessUnitsApi - interface
 * 
 * @export
 * @interface BusinessUnitsApiInterface
 */
export interface BusinessUnitsApiInterface {
    /**
     * Creates request options for businessUnitsGetBusinessUnitByIdGET without sending the request
     * @param {string} id 
     * @param {boolean} [includeChildren] 
     * @throws {RequiredError}
     * @memberof BusinessUnitsApiInterface
     */
    businessUnitsGetBusinessUnitByIdGETRequestOpts(requestParameters: BusinessUnitsGetBusinessUnitByIdGETRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {string} id 
     * @param {boolean} [includeChildren] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessUnitsApiInterface
     */
    businessUnitsGetBusinessUnitByIdGETRaw(requestParameters: BusinessUnitsGetBusinessUnitByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessUnitDto>>;

    /**
     */
    businessUnitsGetBusinessUnitByIdGET(requestParameters: BusinessUnitsGetBusinessUnitByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessUnitDto>;

    /**
     * Creates request options for businessUnitsGetBusinessUnitLookupGET without sending the request
     * @throws {RequiredError}
     * @memberof BusinessUnitsApiInterface
     */
    businessUnitsGetBusinessUnitLookupGETRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessUnitsApiInterface
     */
    businessUnitsGetBusinessUnitLookupGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LookupItemDto>>>;

    /**
     */
    businessUnitsGetBusinessUnitLookupGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LookupItemDto>>;

    /**
     * Creates request options for businessUnitsGetBusinessUnitsCategorySpendingPOST without sending the request
     * @param {GetSpendingRequestDto} [getSpendingRequestDto] 
     * @throws {RequiredError}
     * @memberof BusinessUnitsApiInterface
     */
    businessUnitsGetBusinessUnitsCategorySpendingPOSTRequestOpts(requestParameters: BusinessUnitsGetBusinessUnitsCategorySpendingPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {GetSpendingRequestDto} [getSpendingRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessUnitsApiInterface
     */
    businessUnitsGetBusinessUnitsCategorySpendingPOSTRaw(requestParameters: BusinessUnitsGetBusinessUnitsCategorySpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpendingDto>>>;

    /**
     */
    businessUnitsGetBusinessUnitsCategorySpendingPOST(requestParameters: BusinessUnitsGetBusinessUnitsCategorySpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpendingDto>>;

    /**
     * Creates request options for businessUnitsGetBusinessUnitsCompanySpendingPOST without sending the request
     * @param {GetSpendingRequestDto} [getSpendingRequestDto] 
     * @throws {RequiredError}
     * @memberof BusinessUnitsApiInterface
     */
    businessUnitsGetBusinessUnitsCompanySpendingPOSTRequestOpts(requestParameters: BusinessUnitsGetBusinessUnitsCompanySpendingPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {GetSpendingRequestDto} [getSpendingRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessUnitsApiInterface
     */
    businessUnitsGetBusinessUnitsCompanySpendingPOSTRaw(requestParameters: BusinessUnitsGetBusinessUnitsCompanySpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpendingDto>>>;

    /**
     */
    businessUnitsGetBusinessUnitsCompanySpendingPOST(requestParameters: BusinessUnitsGetBusinessUnitsCompanySpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpendingDto>>;

    /**
     * Creates request options for businessUnitsGetBusinessUnitsOverviewPOST without sending the request
     * @param {BusinessUnitOverviewDtoFilterSortSearchPagedRequestDto} [businessUnitOverviewDtoFilterSortSearchPagedRequestDto] 
     * @throws {RequiredError}
     * @memberof BusinessUnitsApiInterface
     */
    businessUnitsGetBusinessUnitsOverviewPOSTRequestOpts(requestParameters: BusinessUnitsGetBusinessUnitsOverviewPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {BusinessUnitOverviewDtoFilterSortSearchPagedRequestDto} [businessUnitOverviewDtoFilterSortSearchPagedRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessUnitsApiInterface
     */
    businessUnitsGetBusinessUnitsOverviewPOSTRaw(requestParameters: BusinessUnitsGetBusinessUnitsOverviewPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessUnitOverviewDtoPagedResponseDto>>;

    /**
     */
    businessUnitsGetBusinessUnitsOverviewPOST(requestParameters: BusinessUnitsGetBusinessUnitsOverviewPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessUnitOverviewDtoPagedResponseDto>;

    /**
     * Creates request options for businessUnitsGetBusinessUnitsTreeOverviewPOST without sending the request
     * @param {BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto} [businessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto] 
     * @throws {RequiredError}
     * @memberof BusinessUnitsApiInterface
     */
    businessUnitsGetBusinessUnitsTreeOverviewPOSTRequestOpts(requestParameters: BusinessUnitsGetBusinessUnitsTreeOverviewPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto} [businessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessUnitsApiInterface
     */
    businessUnitsGetBusinessUnitsTreeOverviewPOSTRaw(requestParameters: BusinessUnitsGetBusinessUnitsTreeOverviewPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessUnitTreeNodeExtendedDto>>;

    /**
     */
    businessUnitsGetBusinessUnitsTreeOverviewPOST(requestParameters: BusinessUnitsGetBusinessUnitsTreeOverviewPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessUnitTreeNodeExtendedDto>;

    /**
     * Creates request options for businessUnitsGetUnparentedGET without sending the request
     * @throws {RequiredError}
     * @memberof BusinessUnitsApiInterface
     */
    businessUnitsGetUnparentedGETRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessUnitsApiInterface
     */
    businessUnitsGetUnparentedGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LookupItemDto>>>;

    /**
     */
    businessUnitsGetUnparentedGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LookupItemDto>>;

    /**
     * Creates request options for businessUnitsLinkBusinessnUnitsPOST without sending the request
     * @param {LinkBusinessUnitRequestDto} [linkBusinessUnitRequestDto] 
     * @throws {RequiredError}
     * @memberof BusinessUnitsApiInterface
     */
    businessUnitsLinkBusinessnUnitsPOSTRequestOpts(requestParameters: BusinessUnitsLinkBusinessnUnitsPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {LinkBusinessUnitRequestDto} [linkBusinessUnitRequestDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BusinessUnitsApiInterface
     */
    businessUnitsLinkBusinessnUnitsPOSTRaw(requestParameters: BusinessUnitsLinkBusinessnUnitsPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    businessUnitsLinkBusinessnUnitsPOST(requestParameters: BusinessUnitsLinkBusinessnUnitsPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class BusinessUnitsApi extends runtime.BaseAPI implements BusinessUnitsApiInterface {

    /**
     * Creates request options for businessUnitsGetBusinessUnitByIdGET without sending the request
     */
    async businessUnitsGetBusinessUnitByIdGETRequestOpts(requestParameters: BusinessUnitsGetBusinessUnitByIdGETRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling businessUnitsGetBusinessUnitByIdGET().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['includeChildren'] != null) {
            queryParameters['includeChildren'] = requestParameters['includeChildren'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/BusinessUnits/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async businessUnitsGetBusinessUnitByIdGETRaw(requestParameters: BusinessUnitsGetBusinessUnitByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessUnitDto>> {
        const requestOptions = await this.businessUnitsGetBusinessUnitByIdGETRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessUnitDtoFromJSON(jsonValue));
    }

    /**
     */
    async businessUnitsGetBusinessUnitByIdGET(requestParameters: BusinessUnitsGetBusinessUnitByIdGETRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessUnitDto> {
        const response = await this.businessUnitsGetBusinessUnitByIdGETRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for businessUnitsGetBusinessUnitLookupGET without sending the request
     */
    async businessUnitsGetBusinessUnitLookupGETRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/BusinessUnits/lookup`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async businessUnitsGetBusinessUnitLookupGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LookupItemDto>>> {
        const requestOptions = await this.businessUnitsGetBusinessUnitLookupGETRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LookupItemDtoFromJSON));
    }

    /**
     */
    async businessUnitsGetBusinessUnitLookupGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LookupItemDto>> {
        const response = await this.businessUnitsGetBusinessUnitLookupGETRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for businessUnitsGetBusinessUnitsCategorySpendingPOST without sending the request
     */
    async businessUnitsGetBusinessUnitsCategorySpendingPOSTRequestOpts(requestParameters: BusinessUnitsGetBusinessUnitsCategorySpendingPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/BusinessUnits/category-spending`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetSpendingRequestDtoToJSON(requestParameters['getSpendingRequestDto']),
        };
    }

    /**
     */
    async businessUnitsGetBusinessUnitsCategorySpendingPOSTRaw(requestParameters: BusinessUnitsGetBusinessUnitsCategorySpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpendingDto>>> {
        const requestOptions = await this.businessUnitsGetBusinessUnitsCategorySpendingPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SpendingDtoFromJSON));
    }

    /**
     */
    async businessUnitsGetBusinessUnitsCategorySpendingPOST(requestParameters: BusinessUnitsGetBusinessUnitsCategorySpendingPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpendingDto>> {
        const response = await this.businessUnitsGetBusinessUnitsCategorySpendingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for businessUnitsGetBusinessUnitsCompanySpendingPOST without sending the request
     */
    async businessUnitsGetBusinessUnitsCompanySpendingPOSTRequestOpts(requestParameters: BusinessUnitsGetBusinessUnitsCompanySpendingPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/BusinessUnits/company-spending`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetSpendingRequestDtoToJSON(requestParameters['getSpendingRequestDto']),
        };
    }

    /**
     */
    async businessUnitsGetBusinessUnitsCompanySpendingPOSTRaw(requestParameters: BusinessUnitsGetBusinessUnitsCompanySpendingPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SpendingDto>>> {
        const requestOptions = await this.businessUnitsGetBusinessUnitsCompanySpendingPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SpendingDtoFromJSON));
    }

    /**
     */
    async businessUnitsGetBusinessUnitsCompanySpendingPOST(requestParameters: BusinessUnitsGetBusinessUnitsCompanySpendingPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SpendingDto>> {
        const response = await this.businessUnitsGetBusinessUnitsCompanySpendingPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for businessUnitsGetBusinessUnitsOverviewPOST without sending the request
     */
    async businessUnitsGetBusinessUnitsOverviewPOSTRequestOpts(requestParameters: BusinessUnitsGetBusinessUnitsOverviewPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/BusinessUnits/overview`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BusinessUnitOverviewDtoFilterSortSearchPagedRequestDtoToJSON(requestParameters['businessUnitOverviewDtoFilterSortSearchPagedRequestDto']),
        };
    }

    /**
     */
    async businessUnitsGetBusinessUnitsOverviewPOSTRaw(requestParameters: BusinessUnitsGetBusinessUnitsOverviewPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessUnitOverviewDtoPagedResponseDto>> {
        const requestOptions = await this.businessUnitsGetBusinessUnitsOverviewPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessUnitOverviewDtoPagedResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async businessUnitsGetBusinessUnitsOverviewPOST(requestParameters: BusinessUnitsGetBusinessUnitsOverviewPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessUnitOverviewDtoPagedResponseDto> {
        const response = await this.businessUnitsGetBusinessUnitsOverviewPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for businessUnitsGetBusinessUnitsTreeOverviewPOST without sending the request
     */
    async businessUnitsGetBusinessUnitsTreeOverviewPOSTRequestOpts(requestParameters: BusinessUnitsGetBusinessUnitsTreeOverviewPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/BusinessUnits/overview-tree`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: BusinessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDtoToJSON(requestParameters['businessUnitTreeNodeExtendedDtoFilterSortSearchPagedRequestDto']),
        };
    }

    /**
     */
    async businessUnitsGetBusinessUnitsTreeOverviewPOSTRaw(requestParameters: BusinessUnitsGetBusinessUnitsTreeOverviewPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BusinessUnitTreeNodeExtendedDto>> {
        const requestOptions = await this.businessUnitsGetBusinessUnitsTreeOverviewPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BusinessUnitTreeNodeExtendedDtoFromJSON(jsonValue));
    }

    /**
     */
    async businessUnitsGetBusinessUnitsTreeOverviewPOST(requestParameters: BusinessUnitsGetBusinessUnitsTreeOverviewPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BusinessUnitTreeNodeExtendedDto> {
        const response = await this.businessUnitsGetBusinessUnitsTreeOverviewPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for businessUnitsGetUnparentedGET without sending the request
     */
    async businessUnitsGetUnparentedGETRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/BusinessUnits/unparented`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async businessUnitsGetUnparentedGETRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<LookupItemDto>>> {
        const requestOptions = await this.businessUnitsGetUnparentedGETRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(LookupItemDtoFromJSON));
    }

    /**
     */
    async businessUnitsGetUnparentedGET(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<LookupItemDto>> {
        const response = await this.businessUnitsGetUnparentedGETRaw(initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for businessUnitsLinkBusinessnUnitsPOST without sending the request
     */
    async businessUnitsLinkBusinessnUnitsPOSTRequestOpts(requestParameters: BusinessUnitsLinkBusinessnUnitsPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/BusinessUnits/link`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LinkBusinessUnitRequestDtoToJSON(requestParameters['linkBusinessUnitRequestDto']),
        };
    }

    /**
     */
    async businessUnitsLinkBusinessnUnitsPOSTRaw(requestParameters: BusinessUnitsLinkBusinessnUnitsPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.businessUnitsLinkBusinessnUnitsPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async businessUnitsLinkBusinessnUnitsPOST(requestParameters: BusinessUnitsLinkBusinessnUnitsPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.businessUnitsLinkBusinessnUnitsPOSTRaw(requestParameters, initOverrides);
    }

}
